import { SaleNoteDetail } from "../../../../../core";

export const partialCancellation = {
  hasDisabledInput: (element: SaleNoteDetail): boolean => {
    return element['canceled'] 
    || element['originType']==='PRV' 
    || (element['payState'] === 'PAYMENT_PENDING')
    ;
  },
  columns: [
    {
      title: 'SKU',
      name: 'skuCode',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: SaleNoteDetail) => element.skuCode
    },
    {
      title: 'Descripción',
      name: 'description',
      type: 'string',
      editable: false,
      align: 'left',
      value: (element: SaleNoteDetail) => element.description
    },
    {
      title: 'Cant. Disponible',
      name: 'availableItems',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: SaleNoteDetail) => element.availableItems
    },
    {
      title: 'Cant. a eliminar',
      name: 'canceledItems',
      type: 'number',
      editable: true,
      align: 'center',
      value: (element: SaleNoteDetail) => {
        return { num: element.canceledItems, min: 1, max: element.availableItems }
      }
    },
    {
      title: 'Motivo de anulación',
      name: 'reasonCancellation',
      type: 'select',
      editable: true,
      class: 'center',
      placeholderHidden: true,
      value: (element: SaleNoteDetail) =>  element.listMotive  
    }
  ]
};

